/** Voice Template hover Contextual Creation Rail — downstream Generate Audio.
 * Result-zone hover-bridge (Canonical external Quick Actions).
 *
 * TASK-00584: thin wrapper over the Admin-driven
 * `CanvasResultQuickActionRail` (source `generate_voice_template`).
 * `disabled` is only the node-local "needs regeneration" precondition;
 * existence / visibility of the action is Platform Admin config. */

import { AudioOutlined } from '@ant-design/icons'
import type { MouseEvent as ReactMouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import CanvasResultQuickActionRail from './CanvasResultQuickActionRail'

interface Props {
  disabled?: boolean
  disabledReason?: string
  onQuickCreateGenerateAudio: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

export default function VoiceTemplateWorkflowRail({
  disabled,
  disabledReason,
  onQuickCreateGenerateAudio,
  onMouseEnter,
  onMouseLeave,
}: Props) {
  const { t } = useTranslation('canvas')
  return (
    <CanvasResultQuickActionRail
      sourceNodeType="generate_voice_template"
      className="pcv-media-workflow-toolbar--generate-voice-template"
      railTestId="canvas-voice-template-workflow-rail"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      actionHandlers={[
        {
          targetNodeType: 'generate_voice',
          tooltip: t('workflowRail.generateAudio'),
          disabled,
          disabledReason,
          testId: 'canvas-voice-template-quick-generate-audio',
          icon: <AudioOutlined />,
          onClick: (e: ReactMouseEvent) => {
            e.stopPropagation()
            onQuickCreateGenerateAudio()
          },
        },
      ]}
    />
  )
}
